import type { EndUserImages } from '@client/styles/themes/defaultTheme';
import { defaultThemeOptions } from '@client/styles/themes/defaultTheme';
import type { Theme } from '@material-ui/core';
import { createTheme } from '@minna-technologies/minna-ui/styles/themes/minna';

export const anyfinTheme: Theme<EndUserImages> = createTheme<EndUserImages>({
  colors: {
    action: {
      primary: '#0FB56F',
      primaryHover: '#33C084',
      primaryPressed: '#0C9159',
      primaryDisabled: '#DDDDDD',
      secondary: '#818181',
      secondaryPressed: '#4a4b4b',
      secondaryHover: '#4a4b4b',
      secondaryDisabled: '#DDDDDD',
      info: '#FFDCF0',
      infoPressed: '#A38D9A',
      infoHover: '#E6C6D8',
      positive: '#0FB56F',
      positivePressed: '#33C084',
      positiveHover: '#0C9159',
      danger: '#B22C3C',
      dangerPressed: '#B22C3C',
      dangerHover: '#B22C3C',
    },
    textOn: {
      surface: '#222222',
      surfaceSubdued: '#4a4b4b',
      primary: '#ffffff',
      secondary: '#ffffff',
      disabled: 'rgba(34, 34, 34, 0.8)',
      info: '#192133',
      positive: '#1F3D1B',
      danger: '#430D17',
      badge: '#4a4b4b',
    },
    element: {
      rating: '#FFD467',
      badgeSurface: '#FFDCF0',
    },
    base: {
      surface: '#ffffff',
      border: '#B0B0B0',
      background: '#f8f8f8',
      info: '#FFDCF0',
      positive: '#0FB56F',
      danger: '#DD2C4C',
    },
  },
  cardShadow: 'none',
  modalShadow: '0px 0px 0px 1px rgba(229,229,229,1)',
  selectButtonShadowSelected: '00px 3px 3px rgba(34, 34, 34, 0.1), 0px 6px 12px rgba(34, 34, 34, 0.15)',
  selectButtonShadowDefault: '0px 2px 2px rgba(34, 34, 34, 0.2)',
  nextStepShadow:
    '0px 0px 3px rgba(34, 34, 34, 0.2), 0px 2px 5px rgba(34, 34, 34, 0.1), 0px 5px 10px rgba(34, 34, 34, 0.2)',
  floatingShadow:
    '0px 1px 1px rgba(34, 34, 34, 0.06), 0px 2px 3px rgba(34, 34, 34, 0.1), 0px 3px 10px rgba(34, 34, 34, 0.1)',
  borderRadius: '8px',
  transitionDuration: '0.2s',
  borderRadiusPrimaryButton: '14px',
  borderRadiusSecondaryButton: '14px',
  themeButtons: {
    primaryButton: {
      backgroundColor: '#0FB56F',
      color: '#222222',
    },
    positiveButton: {
      backgroundColor: '#0FB56F',
      color: '#FFFFFF',
    },
    secondaryButton: {
      backgroundColor: '#F4F3F0',
      color: '#222222',
      borderWidth: '0px',
    },
    iconFloatingButton: {
      backgroundColor: '#F4F3F0',
      color: '#0FB56F',
    },
    positiveFloatingButton: {
      backgroundColor: '#0FB56F',
      color: '#222222',
    },
  },
  themeFonts: {
    headline1: {
      fontFamily: 'AnyfinSans',
    },
    headline2: {
      fontFamily: 'AnyfinSans',
    },
    headline3: {
      fontFamily: 'AnyfinSans',
    },
    title: {
      fontFamily: 'AnyfinSans',
    },
    buttonText: {
      fontFamily: 'AnyfinSans',
    },
  },
  themeImages: defaultThemeOptions.themeImages, // No custom images
});
